import { IConfiguracaoDocumentoForm } from '../models/configuracaodocumento.model';

export type ConfiguracaoDocumentosModalMode = 'create' | 'edit';

export interface IConfiguracaoDocumentosModalParams {
    documento: IConfiguracaoDocumentoForm;
    mode: ConfiguracaoDocumentosModalMode;
}

export class ConfiguracaoDocumentosModalService {
    static $inject = ['$uibModal'];

    constructor(private $uibModal: ng.ui.bootstrap.IModalService) { }

    public open(params: IConfiguracaoDocumentosModalParams): angular.ui.bootstrap.IModalInstanceService {
        return this.$uibModal.open({
            template: require('html-loader!./configuracaodocumentos.modal.html'),
            controller: 'ConfiguracaoDocumentosModalController',
            controllerAs: '$ctrl',
            backdrop: 'static',
            resolve: {
                entity: () => params.documento,
                mode: () => params.mode,
            },
        });
    }
}
